webpackJsonp([99120839622897],{

/***/ 1642:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"AgedArReportGeneration","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"status","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"ENUM","name":"AgedArReportStatus","ofType":null}}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"topic","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"SCALAR","name":"String","ofType":null}}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-aged-ar-report-generation-c7afa35624e2cad627bc.js